<template>
  <chart-card title="Ticket médio" filter-button :filter-type.sync="filterType" :data="chartData" :chart-loading="loading" is-currency />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import * as helpers from '@/config/helpers.js'
import { colors } from '@/config/colors.js'

export default {
  components: {
    ChartCard,
  },
  data: () => ({
    filterType: 'mensal',
    listaTicketMedioMensal: [],
    listaTicketMedioSemanal: [],
    listaTicketMedioDiario: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    filtro() {
      return {
        unidades: this.stateFilters.unitsConfiguration,
        segmentos: this.stateFilters.segments,
      }
    },
    ticketMedio() {
      if (this.filterType === 'mensal') return this.ticketMedioMensal
      if (this.filterType === 'semanal') return this.ticketMedioSemanal
      if (this.filterType === 'diario') return this.ticketMedioDiario
      return ''
    },
    ticketMedioMensal() {
      return helpers.agrupamentoMensal(this.listaTicketMedioMensal, 'VAL_FATURAMENTO', 'NUM_CUPONS')
    },
    ticketMedioSemanal() {
      return helpers.agrupamentoSemanal(this.listaTicketMedioSemanal, 'VAL_FATURAMENTO', 'NUM_CUPONS')
    },
    ticketMedioDiario() {
      return helpers.agrupamentoDiario(this.listaTicketMedioDiario, 'VAL_TICKET_MEDIO')
    },
    chartData() {
      return {
        labels: [...this.ticketMedio.map((object) => object.data)],
        datasets: [
          {
            label: 'Ticket médio',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [...this.ticketMedio.map((object) => object.valor.toFixed(2))],
            fill: false,
          },
        ],
      }
    },
  },
  watch: {
    filterType() {
      this.getData()
    },
  },
  async mounted() {
    this.$bus.$on('filter', this.getData)

    this.$nextTick(async () => {
      await this.getData()
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      empresaTicketMedio: 'ticket-medio',
    }),
    async getData() {
      try {
        this.loading = true
        if (this.filterType === 'mensal') {
          await this.empresaTicketMedio({ group_field: 'ano,mes', ...this.filtro }).then((data) => {
            this.listaTicketMedioMensal = data
          })
        } else if (this.filterType === 'semanal') {
          await this.empresaTicketMedio({ group_field: 'ano,semana', ...this.filtro }).then((data) => {
            this.listaTicketMedioSemanal = data
          })
        } else if (this.filterType === 'diario') {
          await this.empresaTicketMedio({ group_field: 'anomesdia', ...this.filtro }).then((data) => {
            this.listaTicketMedioDiario = data
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
